import { SC } from "../helper/ServerCall";

export const shippingOptionsService = {
    getShippingOptions,
    storeShippingOption,
    deleteShippingOption
};

function storeShippingOption(data) {
    return SC.postCall(`customer/save-shipping-option`, data);
}

function getShippingOptions(custId) {
    return SC.getCall(`get/customer/shipping-option/${custId}`);
}

function deleteShippingOption(data) {
    return SC.deleteCall(`customer/shipping-option/delete/`+data);
}



// WEBPACK FOOTER //
// ./src/services/shippingOptions.js